// extracted by mini-css-extract-plugin
export default {"DateWrapper":"Date_DateWrapper__SI45t"};